import { useSelector } from "react-redux";
import { SET_LOCATION } from "./types";
import { API_XANO_BASE_URL } from "../../config/api_config";
import { Api_url } from "../../common/api_url";
import axios from "axios";
import { API_GET_LOCATION_WITHOUT_PERMISSION } from "../../config/api_config";
import { API_KEY_LOCATON_WITH_PERMISSION } from "../../config/api_config";
import { axiosAuth, axiosNoAuth } from "../../config/axiosInstances";

export function locationWithPermission(userId, latitude, longitude) {
  return async function (dispatch) {
    try {
      const locationJSON = await axiosNoAuth.get(
        Api_url.GOOGLE_LOCATION_API +
          "?latlng= " +
          latitude +
          "," +
          longitude +
          `&key=${API_KEY_LOCATON_WITH_PERMISSION}`
      );

      const info = locationJSON.data;
      //console.log(info);
      let location = info.plus_code.compound_code;
      location = location.split(",");

      let array_length = location.length;
      const locationObj = {
        city: location[array_length - 3],
        state: location[array_length - 2],
        country: location[array_length - 1],
      };

      const response = await axiosNoAuth.post(
        API_XANO_BASE_URL + Api_url.SendLocation,
        { location_object: locationObj, user_id: userId }
      );

      //console.log("SHOULD NEVER BE CALLED");
      dispatch({ type: SET_LOCATION, payload: location });
    } catch (error) {
      console.log(error);
    }
  };
}

export function locationWithoutPermission(userId) {
  return async function (dispatch) {
    try {
      const location = await axiosNoAuth.get(API_GET_LOCATION_WITHOUT_PERMISSION);
      

      //console.log(location);
      const city = location.data.city;
      const country = location.data.country_name;
      const state = location.data.state;

      const location_object = { city, state, country };
      //console.log(location_object);
      const response = await axiosNoAuth.post(
        API_XANO_BASE_URL + Api_url.SendLocation,
        { location_object, user_id: userId }
      );
      //console.log(response);

      dispatch({ type: SET_LOCATION, payload: location_object });
    } catch (error) {
      console.log(error);
    }
  };
}

export function setLocation(userId) {
  return async function (dispatch) {
    try {
      const { data } = await axios.get(
        API_XANO_BASE_URL + Api_url.GetLocation,
        { params: { user_id: userId } }
      );
      //console.log(data);
      const city = data.city;
      const state = data.state;
      const country = data.country;
      const location_object = { city, state, country };
      // console.log(location_object);
      dispatch({ type: SET_LOCATION, payload: location_object });
    } catch (error) {
      console.log(error);
    }
  };
}
